import React from 'react';
import { Badge } from 'react-bootstrap';

import '../BayTabs.scss';

import BayTooltip from '../../BayTooltip';
import DealTypeIcon from '../../Icons/DealTypeIcon';

interface TabTitleProps {
	withBadge?: boolean;
	count?: number;
	icon?: React.ReactElement | string;
	titleText?: string;
	hideTooltip?: boolean;
}

const TabTitle: React.FC<TabTitleProps> = ({ withBadge, count, icon, titleText, hideTooltip = false }) => (
	<span className="d-inline-flex align-items-center align-content-center">
		{icon ? (
			<span className="mx-2">
				{icon === 'deal' ? (
					<DealTypeIcon
						iconType={titleText === 'Buying Side' ? 'Our Buyer' : 'Our Listing'}
					/>
				) : (
					icon
				)}
			</span>
		) : null}

		{!hideTooltip ? (
			<BayTooltip
				overlay={titleText}
				placement="top"
			>
				<span className="text-truncate">{titleText}</span>
			</BayTooltip>
		) : (
			<span className="text-truncate">{titleText}</span>
		)}
		{count && count > 0 ? (
			withBadge ? (
				<Badge pill bg="success" className="ms-2">
					{count}
				</Badge>
			) : (
				<span className="ms-2 tab-item-count">({count})</span>
			)
		) : null}
	</span>
);

export default TabTitle;
